import React, { useEffect, useState } from 'react';
import "bootstrap/dist/css/bootstrap.css";
import "./assets/scss/paper-dashboard.scss";
import "./assets/demo/demo.css";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import 'devextreme/dist/css/dx.light.css';
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import Login from './views/login/Login';
import Pases_pendientes from './views/pases_pendientes/pases_pendientes';

library.add(fas);

function PrivateRoute({ children, ...rest }) {
  let login = sessionStorage.getItem("login");
  return (
    <Route
      {...rest}
      render={({ location }) => {
        return login
          ? (
            children
          )
          : (
            <Redirect to={{
              pathname: '/',
              state: { from: location }
            }} />
          )
      }}
    />
  );
}


export default function App() {

  return (
    <Router basename="/inventarios">
      <Switch>
        <Route exact path="/" >
          <Login />
        </Route>
        <PrivateRoute path="/pasesPendientes">
          <Pases_pendientes />
        </PrivateRoute>
      </Switch>
    </Router>
  );
}